import parse, { Element } from 'html-react-parser'
import { sanitize } from 'isomorphic-dompurify'

import { ExternalLinkIcon } from '@/components/elements/Icon/ExternalLink'

type Props = {
  text: string
}

const isExternalLink = (domNode: Element) => {
  if (domNode.name !== 'a') {
    return false
  }

  if (domNode.attribs.href.startsWith('https://trial-holdings.inc')) {
    return false
  }

  return true
}

export const HTMLParser = ({ text }: Props) => {
  const parser = (input: string) => {
    return parse(input, {
      replace: (domNode) => {
        if (domNode instanceof Element) {
          if (domNode.attribs.class === 'remove') {
            return <></>
          }

          if (isExternalLink(domNode) && domNode.firstChild?.type === 'text') {
            return (
              <a
                href={domNode.attribs.href}
                rel="noopener noreferrer"
                target="_blank"
              >
                {domNode.firstChild.data}
                <ExternalLinkIcon size="small" />
              </a>
            )
          }
        }
      },
    })
  }

  return <>{parser(sanitize(text))}</>
}
